import { useState } from 'react';
import moment from 'moment/moment';
import { Form, message } from 'antd';

import useTranslation from '../../../../../../hooks/translation/useTranslation';

import PassengerServicesForm from '../../../../../forms/passengersListItemForm/PassengerServicesForm';
import PassengersListItemForm from '../../../../../forms/passengersListItemForm/PassengersListItemForm';

import './CustomMessage.scss';

const requiredFields = [
  'first_name',
  'last_name',
  'id_number',
];

function FillPassengers({
  form,
  rideId,
  services,
  savedPassengers,
  bookingType = false,
}) {
  const { trans } = useTranslation();

  const [previouslyFilledPassenger, setPreviouslyFilledPassenger] = useState(null);

  const passengers = Form.useWatch('passengers', form);
  const formPassengers = Form.useWatch('passengers', form);
  const childPassengerValues = formPassengers?.map((passenger) => passenger.child_passenger);

  const handlePassengerPrice = (passenger, index) => {
    let price = 0;
    if (passenger?.additional_services) {
      Object.keys(passenger?.additional_services)?.forEach((key) => {
        if (passenger?.additional_services?.[key]) {
          price += services?.find((service) => `${service?.id}` === `${key}`)?.amount ?? 0;
        }
      });
    }

    if (passengers?.length > 0) {
      form.setFieldsValue({
        passengers: passengers?.map((p, i) => {
          if (+i === +index) {
            return {
              ...passenger,
              initial_services_price: price,
            };
          }
          return p;
        }),
      });
    }
  };

  const handleFillPassengers = () => {
    const filledPassenger = passengers?.find(
      (passenger) => requiredFields.every((field) => passenger[field]),
    );

    if (filledPassenger) {
      if (moment().diff(moment(filledPassenger?.birth_date), 'years') < 10) {
        message.error({
          content: <div className="custom-message-content">{trans('cannot_fill_passengers_with_child')}</div>,
          className: 'custom-message-container',
          icon: null,
        });
      } else {
        const newSavedPassengers = passengers?.map((passenger) => {
          if (!requiredFields.every((field) => passenger[field])
         || requiredFields.every(
           (field) => previouslyFilledPassenger?.[field] === passenger?.[field],
         )
          ) {
            return {
              ...passenger,
              last_name: filledPassenger?.last_name,
              id_number: filledPassenger?.id_number,
              first_name: filledPassenger?.first_name,
              ...(filledPassenger?.birth_date && {
                birth_date: moment(filledPassenger?.birth_date),
              }),
            };
          }
          return passenger;
        });
        form.setFieldsValue({
          passengers: newSavedPassengers,
        });
        setPreviouslyFilledPassenger(filledPassenger);

        message.success({
          content: <div className="custom-message-content">{trans('passengers_filled_successfully')}</div>,
          className: 'custom-message-container',
          icon: null,
        });
      }
    }
  };

  return (
    <Form form={form} layout="vertical">
      <Form.List name="passengers">
        {(fields) => (
          <div className="flex flex-col gap-10">
            <div className="w-full h-[1px] bg-gray-semi-light-gr" />
            {passengers && fields.map((field, index) => (
              <div
                key={passengers?.[index]?.seat_id}
                className="flex flex-col gap-10"
              >
                <div className="flex gap-6 lg:gap-10 items-baseline flex-col lg:flex-row font-big-bold">
                  <h3 className="text-2xl m-0 leading-[36px]">
                    {trans('passenger')}
                    {' '}
                    {index + 1}
                  </h3>
                  <div className="flex gap-10">
                    <h4 className="text-base m-0">
                      {trans('seat')}
                      {' '}
                      {passengers?.[index]?.seat_number}
                    </h4>
                    <h4 className="text-base m-0">
                      {trans('wagon')}
                      {' '}
                      {passengers?.[index]?.carriage_order_number
                          || passengers?.[index]?.carriage_index}
                    </h4>
                    {passengers?.[index]?.seat_group_property_id === 12 && (
                    <img src="/wagon-icons/disabled.png" width={30} height={30} alt="wheelchair" />

                    )}
                  </div>
                </div>
                {index === 0 && bookingType
                    && (
                      <div className="flex items-center gap-4">
                        <button
                          type="button"
                          className="bg-primary text-white border-none font-big-bold cursor-pointer disabled:bg-[rgb(246,140,146)] duration-300 ease-out p-4 w-fit rounded-lg disabled:cursor-not-allowed"
                          onClick={handleFillPassengers}
                          disabled={
                        !requiredFields?.every((requiredField) => passengers?.[0][requiredField])
                      }
                        >
                          {trans('fill_passengers_button')}
                        </button>
                        <span className="text-[#707070] font-big-bold text-xs">{trans('fill_passengers_description')}</span>
                      </div>
                    )}
                <PassengersListItemForm
                  index={index}
                  savedPassengers={savedPassengers}
                  form={form}
                  formListName="passengers"
                  numberOfPassengers={fields.length}
                  childPassengerValues={childPassengerValues?.[index]}
                  birthRequired={fields.length === 1}
                />
                <PassengerServicesForm
                  index={index}
                  services={services}
                  form={form}
                  handlePassengerPrice={handlePassengerPrice}
                  passenger={passengers?.[index]}
                  rideId={rideId}
                />
                <div className="w-full h-[1px] bg-gray-semi-light-gr" />
              </div>
            ))}
          </div>
        )}
      </Form.List>
    </Form>
  );
}

export default FillPassengers;
